<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.name"
          name="colorName"
          :label="$t('Title')"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('colorName')">{{
          errors.first("colorName")
        }}</span>

        <vs-input
          class="inputx mb-4 mt-1 ltr text-r"
          v-model="model.code"
          name="colorCode"
          :label="$t('ColorCode')"
          v-validate="'required'"
        />

        <input
          type="color"
          v-model="model.code"
          name="colorCode"
          class="inputx mb-4 mt-1 text-r color-input"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('colorCode')">{{
          errors.first("colorCode")
        }}</span>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.vs-con-input input {
  text-align: right;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    colorName: {
      required: "لطفا نام رنگ را وارد نمایید.",
    },
    colorCode: {
      required: "لطفا کد رنگ را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  data() {
    return {
      colorName: "",
      popupTitle: "",
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createColor: "color/create",
      updateColor: "color/update",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          if (this.model.id != null) {
            this.updateColor(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          } else {
            this.createColor(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          }
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        if (this.model.id) {
          this.popupTitle = "EditColor";
        } else {
          this.popupTitle = "CreateNewColor";
          this.model.code = "#027572";
        }
      }
      this.$validator.reset();
      this.disabled = false;
    },
  },
};
</script>
